import { ChangePasswordData } from '@features/auth/domain/ChangePasswordData';
import { ChangePasswordForm } from '@features/auth/domain/ChangePasswordForm';
import { ChangePasswordResponse } from '@features/auth/domain/ChangePasswordResponse';
import changePasswordRequest from '@features/auth/infra/services/changePasswordRequest';
import { AxiosError } from 'axios';
import { useRouter } from 'next/router';
import { useMutation } from 'react-query';

function useChangePasswordMutation() {
  const router = useRouter();

  return useMutation<ChangePasswordResponse, AxiosError, ChangePasswordForm>(
    'changePassword',
    data => {
      const { token } = router.query;
      const { newPassword } = data;
      const changePasswordData: ChangePasswordData = {
        token: token as string,
        newPassword,
      };
      return changePasswordRequest(changePasswordData);
    }
  );
}

export default useChangePasswordMutation;
